import React, { useEffect, useState } from "react";
import StorefrontLayout from "../../components/storefront/StorefrontLayout";
import { useAuth } from "../../lib/auth";
import { api } from "../../lib/api";
import ProductCard from "../../components/storefront/ProductCard";
import { Link } from "react-router-dom";
import { getGuestWishlist } from "../../lib/Wishlist";

export default function Wishlist() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  const load = async () => {
    if (user) {
      const r = await api.get("/api/wishlist");
      setItems(r.data.items || []);
    } else {
      const ids = getGuestWishlist();
      if (!ids.length) { setItems([]); return; }
      // fetch each guest product by id
      const results = await Promise.all(
        ids.map((id) => api.get(`/api/products/${id}`).then((r) => r.data).catch(() => null))
      );
      setItems(results.filter(Boolean));
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  useEffect(() => {
    const h = () => load();
    window.addEventListener("wishlist-changed", h);
    return () => window.removeEventListener("wishlist-changed", h);
    /* eslint-disable-next-line */
  }, [user]);

  return (
    <StorefrontLayout>
      <div className="px-6 lg:px-12 py-10">
        <h1 className="font-display text-4xl text-maroon">My Wishlist</h1>
        <div className="royal-divider my-6"/>
        {!user && items.length > 0 && (
          <div className="bg-gold/10 border border-gold rounded-lg p-3 text-sm text-ash mb-6">
            These are saved on this device. <Link to="/login" className="text-maroon underline">Login or sign up</Link> to keep them on your account.
          </div>
        )}
        {items.length === 0 ? (
          <div className="text-center py-20 text-ash">No pieces wishlisted yet. <Link to="/catalog" className="text-maroon underline">Start browsing →</Link></div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {items.map((p) => (<ProductCard key={p.id} product={p} />))}
          </div>
        )}
      </div>
    </StorefrontLayout>
  );
}